module.exports = __webpack_public_path__ + "static/media/fb-default-profile.b4c8108b.svg";